export const FONT_SANS_ORI = 'SansOri, SansOriFallback, sans-serif';
export const CAROUSEL = 'Carousel';
export const CAROUSEL_WRAPPER = 'CarouselWrapper';
export const CAROUSEL_PREVIOUS_ARROW = 'CarouselPreviousArrow';
export const CAROUSEL_NEXT_ARROW = 'CarouselNextArrow';
export const CAROUSEL_SLIDE = 'CarouselSlide';
export const IMAGE = 'Image';
export const VIDEO = 'VideoWrapper';
export const VIDEO_PLAY_BUTTON = 'VideoPlayButton';
export const VIDEO_PLAYER = 'VideoPlayer';
export const IMAGE_PLACEHOLDER = 'ImagePlaceholder';
export const IMAGE_PLACEHOLDER_BACKGROUND = 'ImagePlaceholderBackground';
export const PAGINATION_STEP = 'PaginationStep';
//# sourceMappingURL=carousel.js.map